// src/components/list/PanelDisplayFolders.tsx

import { ExpandMoreTwoTone } from '@mui/icons-material'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  Chip,
  FormControlLabel,
  FormGroup,
  Input,
  Stack,
  Typography,
} from '@mui/material'
import { useState } from 'react'

import { FolderPool } from '@/types/domain/folder'
import { SensorPool } from '@/types/domain/sensor'

import { HStack } from '..'
import { useFolderPool, useSensorPool } from '../../hooks'

type PanelDisplayFoldersProps = {
  onChange: (folders: number[]) => void
  onChangeSelectedSensors: (sensors: number[]) => void
  selected: number[]
}

export const PanelDisplayFolders = ({
  onChange,
  onChangeSelectedSensors,
  selected,
}: PanelDisplayFoldersProps) => {
  const fPool: FolderPool = useFolderPool()
  const sPool: SensorPool = useSensorPool()

  const [foldersSearch, setFoldersSearch] = useState<string>('')
  const [showSelectedFolders, setShowSelectedFolders] = useState<boolean>(false)

  const FILTER_SEARCH = f =>
    f.attributes.name.toLowerCase().includes(foldersSearch.toLowerCase())

  const FILTER_SELECTED_FOLDERS = f =>
    showSelectedFolders ? selected.includes(f.attributes.entity_id) : true

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreTwoTone />}>
        <HStack sx={{ width: 1 }}>
          <Chip label={`${selected.length}/${fPool.length}`} />

          <Typography>Gebäude</Typography>
        </HStack>
      </AccordionSummary>

      <AccordionDetails>
        <HStack sx={{ width: 1 }}>
          <FormGroup>
            <FormControlLabel
              label={'Nur ausgewählte Gebäude anzeigen'}
              control={
                <Checkbox
                  checked={showSelectedFolders}
                  onClick={() => setShowSelectedFolders(prev => !prev)}
                />
              }
            />
          </FormGroup>
        </HStack>

        <HStack sx={{ width: 1 }}>
          <Stack sx={{ width: 1 }}>
            <Input
              onChange={event => setFoldersSearch(event.target.value)}
              placeholder={'Suchen ...'}
              sx={{ m: 0, minHeight: 23, pl: 1 }}
              value={foldersSearch}
            />
            <FormGroup>
              {fPool
                .filter(FILTER_SEARCH)
                .filter(FILTER_SELECTED_FOLDERS)
                .map(f => {
                  const { name, entity_id } = f.attributes
                  const checked = selected.includes(entity_id)

                  const onChangeFn = () => {
                    if (!selected.includes(entity_id)) {
                      const entityIds = sPool
                        .filter(f => f.attributes.folder_id === entity_id)
                        .map(item => item.attributes.entity_id)

                      onChangeSelectedSensors(
                        sPool
                          .map(s => s.attributes.entity_id)
                          .filter(id => !entityIds.includes(id))
                      )
                    }

                    onChange(
                      selected.includes(entity_id)
                        ? selected.filter(f => f !== entity_id)
                        : [...selected, entity_id]
                    )
                  }

                  const control = (
                    <Checkbox
                      checked={checked}
                      name={name}
                      onChange={onChangeFn}
                    />
                  )

                  return (
                    <FormControlLabel
                      control={control}
                      key={entity_id}
                      label={name}
                    />
                  )
                })}
            </FormGroup>
          </Stack>
        </HStack>
      </AccordionDetails>
    </Accordion>
  )
}
